import React from 'react';
import { SensorCardsRow } from './SensorCardsRow';
import { StateMachineViz } from './StateMachineViz';
import { SceneFeed } from './SceneFeed';
import { EventLogColumns } from './EventLogColumns';

export function CenterPanel() {
  return (
    <div className="center-panel">
      <SensorCardsRow />
      <StateMachineViz />
      <SceneFeed />
      <EventLogColumns />
    </div>
  );
}
